// Template283: Bali - Día genérico (Page3-style)
// Cabecera verde, hero image + sticker + title, intro, bloques (titulo + contenido, opcional imagen, SabiasQue, sticker+tipBox), caja final opcional.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template283 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const heroTitle = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const logoImage = getCanvasImageUrl("logo");
	const blocks = Array.isArray(page?.data?.blocks) ? page.data.blocks : [];
	const footerBox = page?.data?.footerBox;
	const actualHeaderColor = headerBackgroundColor || "#2F6B4F";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: 0.5,
		marginTop: 1,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{portadaImage && (
				<Box sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt=""
							sx={{ width: 100, position: "absolute", bottom: 55, left: 21 }}
						/>
					)}
					{heroTitle && (
						<Box
							component="span"
							sx={{
								fontSize: 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: 1.25,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
							dangerouslySetInnerHTML={{ __html: heroTitle }}
						/>
					)}
				</Box>
			)}

			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				{intro && (
					<Box component="p" sx={estiloP}>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 2,
						position: "relative",
						marginTop: 1.5,
					}}
				>
					{blocks.map((block, idx) => {
						const blockImage = block.imageId
							? getImageSrc(block.imageId)
							: null;
						const sabiasQueList = Array.isArray(block.sabiasQue)
							? block.sabiasQue
							: [];
						const stickerImageId = block.stickerImageId;
						const tipBox = block.tipBox;
						const stickerImage = stickerImageId
							? getImageSrc(stickerImageId)
							: null;
						const isStickerTipBlock = !blockImage && (stickerImage || tipBox);

						if (isStickerTipBlock) {
							return (
								<Box key={idx} data-block-id={`text-${idx + 3}`} sx={{ position: "relative" }}>
									<Box sx={{ width: "80%", marginTop: isSmallScreen ? 8 : 0 }}>
										{block.titulo && (
											<Box
												component="h3"
												sx={{ ...estiloH3, marginTop: isSmallScreen ? 0 : 1 }}
											>
												{block.titulo}
											</Box>
										)}
										{block.contenido && (
											<Box component="p" sx={estiloP}>
												{block.contenido}
											</Box>
										)}
									</Box>
									{stickerImage && (
										<Box
											component="img"
											src={stickerImage}
											alt=""
											sx={{
												width: 100,
												position: "absolute",
												bottom: isSmallScreen ? 50 : 0,
												right: -10,
											}}
										/>
									)}
									{tipBox && (tipBox.titulo || tipBox.texto) && (
										<Box
											sx={{
												position: "absolute",
												bottom: isSmallScreen ? 90 : 50,
												right: isSmallScreen ? 70 : 60,
												backgroundColor: "#fff8db",
												border: "2px solid #f5c400",
												borderRadius: "12px 12px 0 12px",
												padding: "10px 12px",
												fontSize: 11,
												color: "#444",
												boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
												maxWidth: 200,
											}}
										>
											{tipBox.titulo && <strong>{tipBox.titulo}</strong>}{" "}
											{tipBox.texto}
										</Box>
									)}
								</Box>
							);
						}

						return (
							<Box
								key={idx}
								data-block-id={`text-${idx + 3}`}
								sx={{
									display: "flex",
									gap: 2.5,
									alignItems: "flex-start",
									position: "relative",
								}}
							>
								{blockImage && (
									<Box
										component="img"
										src={blockImage}
										alt=""
										sx={{
											width: "40%",
											height: 110,
											borderRadius: "12px",
											objectFit: "cover",
											flexShrink: 0,
										}}
									/>
								)}
								{sabiasQueList.length > 0 &&
									sabiasQueList.map((sq, i) => (
										<Box
											key={`sq-${idx}-${i}`}
											sx={{
												position: "absolute",
												top: i * 40,
												left: "35%",
												zIndex: 2,
											}}
										>
											<SabiasQue
												icono={sq.icono || "💬"}
												texto={sq.texto || ""}
											/>
										</Box>
									))}
								<Box
									sx={{
										width: blockImage ? "60%" : "100%",
										position: "relative",
									}}
								>
									{block.titulo && (
										<Box component="h3" sx={estiloH3}>
											{block.titulo}
										</Box>
									)}
									{block.contenido && (
										<Box component="p" sx={estiloP}>
											{block.contenido}
										</Box>
									)}
								</Box>
							</Box>
						);
					})}
				</Box>

				{footerBox?.content && (
					<Box
						data-block-id="text-footer"
						sx={{
							backgroundColor: "#c8e6d4",
							border: "3px solid #2F6B4F",
							borderRadius: "12px",
							padding: "16px 20px",
							fontSize: 12,
							color: "#333",
							width: isSmallScreen ? "100%" : "100%",
							marginTop: 2,
						}}
					>
						<Box component="p" sx={{ ...estiloP, fontSize: 13 }}>
							{footerBox.content}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template283.thumbnail = "/images/template-1.png";
export default Template283;
